import React, { Component, Fragment } from 'react';

import { removeLayer } from '@ro-utils/common/helpers';
import { textMarker } from '@ro-utils/common/map/textmarker';
import { asString } from '@ro-utils/common/helpers';

import { LAYER_SNOW_COVER } from '@ro-utils/constant';

class SnowCover extends Component {
  setSnowdata(props) {
    const { data, map, index } = props;
    map && removeLayer(LAYER_SNOW_COVER, map);
    map &&
      data &&
      textMarker({
        item: data,
        type: LAYER_SNOW_COVER,
        offset: -15,
        unit: 'cm',
        uitype: LAYER_SNOW_COVER,
        layerIndex: index
      });
  }
  componentDidMount() {
    this.setSnowdata(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (asString(nextProps.data) !== asString(this.props.data)) {
      this.setSnowdata(nextProps);
    }
  }
  render() {
    return <Fragment />;
  }
}

export default SnowCover;
